module.exports = __webpack_public_path__ + "img/Halle_Leer 084.dd07b7d6.jpg";